import { CompaniesBundlingStopService_companiesBundlingStopServiceGetEntity } from '@festina/moneyin-general-types/moneyin/hooks/CompaniesBundlingStopService_companiesBundlingStopServiceGetEntity'

export const useFetchMoneyInCompaniesBundlingStops =
  CompaniesBundlingStopService_companiesBundlingStopServiceGetEntity.useSuspenseQuery
